// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { showShareUtilSelector } from '../../../workspace/header/currentBoardHeader/currentBoardHeaderSelector';
import { selectIsScreenLandscape } from '../../../platform/platformSelector';

// Components
import MobileShareUtil from './MobileShareUtil';
import MobileReadOnlyStatusMessage from './MobileReadOnlyStatusMessage';

const MobileHeaderRightSection: React.FC = () => {
    const isShareUtilEnabled = useSelector(showShareUtilSelector);
    const isLandscape = useSelector(selectIsScreenLandscape);

    let renderComponent = null;

    if (isLandscape) {
        renderComponent = <MobileReadOnlyStatusMessage />;
    } else if (isShareUtilEnabled) {
        renderComponent = <MobileShareUtil />;
    }

    return <div className="MobileHeaderRightSection right-section">{renderComponent}</div>;
};

export default MobileHeaderRightSection;
